import PageHeader from 'components/PageHeader';
import ListCreateButton from 'components/buttons/ListCreateButton';
import PaddedLayout from 'layout/MainLayout/PaddedLayout';
import { useNavigateWithReturnState } from 'utils/useNavigateWithReturnState';
import EffortsTableWithFilters from './EffortsTable';

const EffortsPage = (): JSX.Element => {
    const navigateWithReturn = useNavigateWithReturnState();

    return (
        <PaddedLayout className="overflow-hidden">
            <div className="flex h-full flex-col gap-4">
                <PageHeader
                    hostsList
                    titleId={'efforts.bd-efforts'}
                    showBreadcrumb
                    buttons={
                        <div>
                            <ListCreateButton
                                permissions={['CREATE.EFFORTS']}
                                variant="contained"
                                color="secondary"
                                size="small"
                                onClick={() => navigateWithReturn(`/effort/new`)}
                                labelId="efforts.add-new-effort"
                                newLabelId="new-entity.bd-effort"
                            />
                        </div>
                    }
                />
                <EffortsTableWithFilters />
            </div>
        </PaddedLayout>
    );
};

export default EffortsPage;
